export enum ReviewStatus {
  DRAFT = "DRAFT",
  S0_GENERATED = "S0_GENERATED",
  S1_GENERATED = "S1_GENERATED",
  S2_GENERATED = "S2_GENERATED",
  BASE_POG_GENERATED = "BASE_POG_GENERATED",
  STORE_POG_GENERATED = "STORE_POG_GENERATED",
  STORE_POG_EXPORTED = "STORE_POG_EXPORTED",
}
